module.exports = function(ratings) {
	"use strict";
  ratings
  .controller('allratingsController', allratingsController)
	allratingsController.$inject = ["$filter","watchAllCheckboxesNgTable","$timeout","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","reqursiveService","deleteDataService","alertService","putDataService","serverError","offlineError"];
	
  function allratingsController($filter,watchAllCheckboxesNgTable,$timeout,$stateParams,$state,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,deleteDataService,alertService, putDataService,serverError,offlineError) {
    var vmratings = this;
    var state = 'ratings';
    var s;
    var role;
    var date_start;
    var date_end;
    var sortby ='date';
    var $data;
    var page;
    vmratings.status = 'publish';
    var status = 'publish';
    vmratings.selectedTitle = -1;
    vmratings.editRatingShow = false;
    vmratings.selectedRole = {value: 'all'}; 
    vmratings.selectedBulkAction = {value: 'default'};
    vmratings.checkedPostsEdit = [];
    vmratings.checkboxes = { 'checked': false, items: {}};
    vmratings.ratingId = $stateParams.id; 
    if($stateParams.id) {
      vmratings.editRatingShow = true;
    } else {
      vmratings.editRatingShow = false;
    }
    $scope.ranges = {
      'Today': [moment().startOf('day'), moment()],
      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
      'Last 7 days': [moment().subtract('days', 7), moment()],
      'Last 30 days': [moment().subtract('days', 30), moment()],
      'This month': [moment().startOf('month'), moment().endOf('month')],
      'All days':[moment().subtract('year',5),moment()]
    };
    vmratings.bulkAction = function(param) {
      if(param != 'default' && vmratings.checkedPostsEdit.length>0 ) {
        var putFunction = function() { 
          putDataService.update({
            param1:state, 
            param2: 'bulk',
            param3:'delete'
          },{
            'delete_ids':vmratings.checkedPostsEdit,
          }).$promise.then(function(bulkDelete){
            watchAllCheckboxesNgTable.resetCheckBox(vmratings)
            vmratings.selectedBulkAction = {value: 'default'}; 
            alertService('success','Success ', bulkDelete.message, 2000);
            vmratings.tableParams.reload();
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    putFunction();
                  }
                },
                function(error) {
                  // report something
                },
                function(progress) {
                 // report progress
              });
            }else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            } 
            watchAllCheckboxesNgTable.resetCheckBox(vmratings)
            vmratings.selectedBulkAction = {value: 'default'}; 
          });
        }
        putFunction();
      }
    }
    watchAllCheckboxesNgTable.watch($scope, vmratings)
    vmratings.checkedPost = function(ratingId, checked) {
      if(checked) {
        vmratings.checkedPostsEdit.push(ratingId);
      } else {
        if(vmratings.checkedPostsEdit.includes(ratingId)) {
          var id_tag = ratingId;
          var position = vmratings.checkedPostsEdit.indexOf(id_tag);
          vmratings.checkedPostsEdit.splice(position, 1);
        }
      }
    }
    vmratings.editTitle = function(index) {
      vmratings.selectedTitle = index;
    }
    vmratings.cancelEditTitle = function() {
      vmratings.selectedTitle = -1;
    }
    vmratings.editRating = function(ratingId) {
      
      vmratings.editRatingShow = true;
      jQuery("html, body").animate({
        scrollTop: 0
      }, 600);
      vmratings.ratingId = ratingId;
      $state.transitionTo('app.allratings', {id: vmratings.ratingId}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    vmratings.updateStatus = function(item,status) {
      $rootScope.hasLoaded = false;
        var updateData = {
          'title': item.title,
          'content': item.content,
          'status': status,
          'data':item.data.answers,
          'multiple': item.multiple,
          'max_choices': item.max_choices,
          "image": item.image,
          "expire_date": (status == 'finish')? $filter('date')(new Date().toISOString(), "MMM d, y HH:mm"): null,
          "ads": item.ads
        }
      var putFunction = function() {
        putDataService.update({
          param1:'ratings', 
          param2:item._id
        },updateData).$promise.then(function(putRating){
            $rootScope.hasLoaded = true;
            vmratings.tableParams.reload();
            alertService('success','Success ', putRating.message, 2000);
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  putFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else if(error.status ==502) {
            serverError()
          }else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;  
        });
      }
      putFunction();
    }
    vmratings.deleteRating = function(ratingId) {
      var deleteFunction = function() {
        deleteDataService.remove({
          param1:'ratings', 
          param2: ratingId
        }).$promise.then(function(deleteRating){ 
          alertService('success','Success ', deleteRating.message, 2000);
          vmratings.tableParams.reload();
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  deleteFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }  
        });
      }
      deleteFunction();
    }
    vmratings.changeSearch = function(search_data) {
      if(search_data) {
        s = search_data;
      } else {
        s = null;
        $timeout(function() {
          vmratings.search();
        },0)            
      }
    }
    vmratings.changeDate = function(value) {
      vmratings.dateRangevalue= value;
      if(vmratings.dateRangevalue) {
        if(value.startDate && value.endDate) {
          date_start = value.startDate.format('YYYY-MM-DD');
          date_end = value.endDate.format('YYYY-MM-DD');
        } else {
          date_start = null;
          date_end = null;
        }
      } else {
          date_start = null;
          date_end = null;
      }
    }
    vmratings.changeStatus =function(event,activeStatus) {
      vmratings.status = activeStatus;
      if(activeStatus == 'all') {
        status = null;
      } else {
        status = activeStatus;
      }
      reloadTableFunction();
    }
    function reloadTableFunction() {
      if(vmratings.tableParams.page() ==1) {
        vmratings.tableParams.reload();
      } else {
        vmratings.tableParams.page(1);
      }
    } 
    vmratings.resetAllFilters = function() {
      vmratings.searchData = null;
      s =null;
      status = 'publish'
      date_start = null;
      date_end = null;
      $scope.$broadcast('clear-daterange',true);
      reloadTableFunction();
    }
    // vmavo.changeStatus =function(event,activeStatus) {
    //   s=null;
    //   date_start = null;
    //   date_end= null;
    //   reloadTableFunction
    // }
     vmratings.search =function(value) {
      if(value) { 
        s = value.toLowerCase();
      } else {
        s = null;
      }
      reloadTableFunction();
    }
    vmratings.tableReloadFunction = function(page) { 
      vmratings.tableParams = new NgTableParams({
          page: page || 1,
          count: 20,
          
      }, {
        getData: function(params) {
          $rootScope.emptyTable = false;
          $rootScope.hasLoaded = false;
          return getDataService.get({
            param1: state,
            param2: null,   
            s:s,
            status: status,
            sortby: $rootScope.sortby,
            sort : $rootScope.sort,
            date_start: date_start,
            date_end: date_end,
            page: params.page(),
            limit: params.count(),
            }).$promise.then(function(data){
            
            $rootScope.hasLoaded = true;
            $data = data.ratings;
            vmratings.dataGet = data.ratings; 
            if(data.ratings.length == 0) {
              $rootScope.emptyTable = true;
            } else {
              $rootScope.emptyTable = false;
            }
            watchAllCheckboxesNgTable.resetCheckBox(vmratings) 
            params.total(data.count);
            params.numPages(data.max_pages);
            jQuery('.goTo input').val("");
            return $data;
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError('refresh')
              $rootScope.hasLoaded = true;
              return
            }
            if(error.status ==401) {
            // $rootScope.refreshToken =true;
              
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                 
                  if(answer==200) {
                    vmratings.tableReloadFunction(params.page());
                  }
                  // do something
                },
                function(error) {
                  // report something
                },
                function(progress) {
                 // report progress
                });
            } else if(error.status ==404) {
              $rootScope.emptyTable = true;
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }
            $rootScope.hasLoaded = true;
          });
        }    
      });
    }
    vmratings.tableReloadFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/ratingModule/allratings/js/allratingsController.js
// module id = 574
// module chunks = 0